'use strict';

exports = module.exports = require('./dagLink');
exports.util = require('./util');